import { ChangeDetectionStrategy,Component, SecurityContext} from '@angular/core';
import {MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import {IrbCommonModule} from "@irb-common/irb-common.module";
import {MatButton} from "@angular/material/button";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import {ModelsService} from "@irb/irb-models/models-new/models.service";
import {IrbAppEvents} from "@irb/app.events";
import {DomSanitizer} from "@angular/platform-browser";
import {UtilityService} from "@irb-common/services/utility.service";


@Component({
  standalone: true,
  selector: 'irb-dialog-syntax-sso',
  templateUrl: './dialog-syntax-sso.component.html',
  styleUrl: './dialog-syntax-sso.component.scss',
  imports: [MatDialogModule, IrbCommonModule, MatButton ],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DialogSyntaxSsoComponent {
  dialogTitle = 'You Are Leaving Schwab Advisor Center®';
  sacAgreementsAndDisclosuresUrl: any;

  constructor(
    public dialogRef: MatDialogRef<DialogSyntaxSsoComponent>,
    private ats: AnalyticsService,
    public as: AppService,
    private modelsService: ModelsService,
    private sanitizer: DomSanitizer,
    private util: UtilityService
  ) {
  }

  close() {
    this.ats.trackClickEvent("md_syntax_cncl")
    this.dialogRef.close();
  }

  continue() {
    this.ats.trackClickEvent("md_syntax_cont");
    let url = '';
    this.modelsService.getSyntaxRedirect().subscribe({
        next: (res: any) => {
          this.openSyntax(res);
        },
        error: (_err: any) => {
          this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dType: 'NONE',
            dTitle: 'Syntax Unavailable',
            dProceedBtnLabel: '',
            msg: 'There’s a connection issue with iRebal and Syntax. Please try again later. If you continue to have issues, contact iRebal Support at (855) 640-2472.',
            onCancel: () => {
              this.close();
            }
          });
        }
    });
  }

  openSyntax(url: string) {
    window.open(this.sanitizer.sanitize(SecurityContext.URL, url), "_blank");
    this.close();
    this.dialogRef.close();
  }

  openAgreements() {
    let url = 'https://' + this.util.getSACShellDomain();
    url += '/important-info/agreements-disclosures';
    const windowParameter = 'toolbar=no,scrollbars=yes,resizable=yes,width=1000,height=750';
    window.open(this.sanitizer.sanitize(SecurityContext.URL, url), 'Agreements', windowParameter);
  }
}

